<!--
	LICENSE MIT
	Thanks to Ashlee Phillips (https://ashleephillips.com/)
	See https://codepen.io/smashlee/pen/jVOrOw
-->
<section class="granny">
	<div class="granny-head">
		<div class="right-bottom-bang"></div>

		<div class="right-top-bang"></div>

		<div class="left-bottom-bang"></div>

		<div class="left-top-bang"></div>

		<div class="granny-face">
			<div class="left-eye"></div>
			<div class="right-eye"></div>
			<div class="glasses">
				<div class="left-lens"></div>
				<div class="right-lens"></div>
				<div class="line"></div>
			</div>
		</div>
	</div>

	<div class="granny-top-knot"><div class="box"></div></div>
</section>
